export const mentionCandidates = [{ id: 0, display: "PREP" }];

// @[display](id) 형태의 멘션 파싱 정규식
export const mentionRegex = /@\[[^\]]+\]\((\d+)\)/g;
